export const GET_GQL_SCHEMA: string = 'getGqlSchema' 
